import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import FilterCustom from 'components/Tvendo/Common/FilterCustom';

import { wsFindBy } from 'services/WService.js';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
  },
  totals: {
    marginTop: '15px',
    fontWeight: 'bold',
  },
};

const useStyles = makeStyles(styles);
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 130 },
  { Header: 'Nombre Cliente', accessor: 'CardName' },
  { Header: 'Fec. Creado', accessor: 'created_at', width: 140 },
  { Header: 'Vendedor', accessor: 'SlpName', width: 150 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 150 },
  { Header: 'Ruta', accessor: 'base_route_description' },
  { Header: 'Total de orden', accessor: 'total_order' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
export default function CustomerQuery() {
  const classes = useStyles();
  const [customers, setCustomers] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listCustomers(filter) {
    setDataLoading(true);
    // setCustomers([]);
    const response = await wsFindBy('base/business-partner/created-at', filter);
    setDataLoading(false);
    if (response.success) setCustomers(response.data);
  }

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'black' }}>
          <span className={classes.cardIconTitle}>Listado de Clientes</span>
          {dataLoading && <LoadingSpinner />}
          <div className={classes.totals}>
            <span>Clientes: {customers?.length}</span>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <FilterCustom getFilter={listCustomers} dateRange diffRange={0} zone />

        <ReactTable
          excelName="Consulta-clientes"
          defaultWidth={1000}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={customers.map((item, i) => {
            return {
              num: i + 1,
              CardCode: item.CardCode,
              CardName: item.CardName,
              created_at: item.created_at,
              SlpName: item.SlpName || '-',
              base_zone_description: `${item.base_zone_code || ''} - ${
                item.base_zone_description || ''
              }`,
              base_route_description: item.base_route_description,
              total_order: parseFloat(item.total_order).toFixed(2),
              actions: '',
            };
          })}
        />
      </CardBody>
    </Card>
  );
}
